import { Round } from '../models/round.model';
import { generateInitialMatches } from './generate-initial-matches';
import { generateRemainingRounds } from './generate-remaining-matches';

export const generateMatches = (
  teamsTotal: number,
  capacityRoundSlots: number,
  capacityTeamsTotal: number,
  playInTeamsTotal: number,
  roundsTotal: number
): Round[] => {
  const initialRounds = generateInitialMatches(
    teamsTotal,
    capacityRoundSlots,
    capacityTeamsTotal,
    playInTeamsTotal
  );

  const additionalRounds = generateRemainingRounds(
    roundsTotal,
    initialRounds.playInRound.matches,
    initialRounds.capacityRound.matches
  );

  const combined = [
    initialRounds.playInRound,
    initialRounds.capacityRound,
    ...additionalRounds,
  ];

  return combined;
};
